<template>
  <div class="option-item" :class="levelInfo.isAppenCard ? 'option-card' : ''">
    <template v-if="!levelInfo.isAppenCard">
      <!-- 默认模式 -->
      <span class="option-item-text" :style="[info.fontStyle]">{{ getValue }}</span>
      <div class="option-item-tag-list" v-if="levelInfo.tagInfo && getValue !== '全部'">
        <template v-for="tag in levelInfo.tagInfo.tagList">
          <lTag :key="tag.id" v-if="isAppenTag(tag)" :info="tag" :type="levelInfo.tagInfo.colorType" />
        </template>
      </div>
      <div class="option-item-todo-list">
        <buttonComp 
          v-for="(item, index) in getTodoList" 
          v-bind="$attrs"
          :key="index"
          :tableData="getRow"
          :approvalId="applyInfo.id || applyInfo.approvalId"
          :info="{ info: item }"
          @todo-inside="$emit('todo-inside', { row: getRow, insideInfo: $event })"
          @todo-outside="$emit('todo-inside', { row: getRow, insideInfo: $event })"
          @custom-scene="$emit('custom-scene',$event)"
          @to-nav="$emit('to-nav',{ row: getRow, insideInfo:$event })"
          @open-appDialog="$emit('open-appDialog', $event)"
          @open-dictionary="$emit('open-dictionary',$event)"
        />
      </div>
    </template>
    <template v-else>
      <!-- 卡片模式 -->
      <div class="option-item-card">
        <template v-if="levelInfo.cardConfig">
          <CardForm 
            :data="getRow" 
            :cardConfig="levelInfo.cardConfig" 
            :isNewCard="true"
            :tickList="tickList"
            :isAppenTag="isAppenTag"
            @openAppInitiate="$emit('openAppInitiate', $event)"
            @edit-user-info="$emit('edit-user-info', $event, getRow)"
            @open-appDialog="$emit('open-appDialog', $event)"
            @custom-scene="$emit('custom-scene',$event)"
          />
        </template>
        <template v-else>
          请配置卡片模式
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { isObject } from '@/components/schoolInstrument/mixins/utils';
import { isConditionAppen } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { getOrgShowName } from '@/api/global'
import buttonComp from '../button/index.vue'
import CardForm from '@/components/common/card/cardForm.vue'
import lTag from './lTag'
export default {
  // 组件名称
  name: 'optionItem',
  // 组件参数 接收来自父组件的数据
  props: {
    selInfo: {
      type: [String, Object, Array, Number],
      default: ()=> ({}),
    },
    realValue: {
      type: [String, Object, Array, Number],
      default: ()=> ({}),
    },
    info: {
      type: Object,
      default: () => {},
    },
    themeColor: {
      type: String,
      default: '#4e86ff'
    },
    applyInfo: {
      type:Object,
      default: ()=>({})
    },
    styleInfo: {
      type:Object,
      default: ()=>({})
    },
    treeLevel: {
      type: Number,
      default: 1
    },
    tickList: {
      type: Array,
      default: ()=> ([])
    },
    customDeskId: {},
    moreFiledData: {
      type: Object,
      default: () => ({})
    }
  },
  // 局部注册的组件
  components: {
    buttonComp,
    CardForm,
    lTag
  },
  // 组件状态值
  data() {
      return {}
  },
  // 计算属性
  computed: {
    levelInfo() {
      if (!this.info) return {}
      const screenLevel = this.info.screenLevel
      if (screenLevel && screenLevel.levelList) {
        let ele = []
        if (screenLevel.levelType === 'single') {
          ele = screenLevel.levelList[0]
        } else {
          ele = screenLevel.levelList[this.treeLevel - 1]
        }
        return ele
      } else {
        return {}
      }
    },
    getRow() {
      if (!this.info) return {}
      const screenLevel = this.info.screenLevel
      if (screenLevel && screenLevel.levelList) {
        let ele = {}
        if (screenLevel.levelType === 'single') {
          ele = screenLevel.levelList[0]
        } else {
          ele = screenLevel.levelList[this.treeLevel - 1]
        }
        const field = ele.field || []
        // eslint-disable-next-line no-unused-vars
        const [title, name, type] = field.split('_')
        let date = {}
        if (['text', 'orders', 'status', 'textarea', 'radio', 'checkbox', 'label', 'time', 'number'].includes(type)) {
          date[title] = this.getValue
        } else if (['relation-user', 'appuser'].includes(type)) {
          // 联系人控件
          if (Array.isArray(this.selInfo)) {
            date[title] = this.selInfo
          } else {
            date[title] = [{
              userId: this.selInfo.userId,
              realname: this.selInfo.value || this.selInfo.realname,
            }]
          }
        }
        if (Object.keys(this.moreFiledData).length > 0 && this.moreFiledData[this.getValue]) {
          date = { ...this.moreFiledData[this.getValue], ...date }
        }
        return date
      } else {
        return {}
      }
    },
    getValue() {
      if (Array.isArray(this.selInfo)) {
        return this.selInfo.map(item => {
          if (item.organizationId) {
            return getOrgShowName(item)
          } else {
            return item.realname || item.name
          }
        }).join(',')
      } else if (isObject(this.selInfo)) {
        return this.selInfo.value
      } else {
        return this.selInfo
      }
    },
    getRealValue() {
      if (this.selInfo === '全部') return
      const value = this.realValue[0]
      console.log(Array.isArray(value), isObject(value), typeof value === 'string')
      if (Array.isArray(value)) {
        return value.map(item => {
          if (item.organizationId) {
            return getOrgShowName(item)
          } else {
            return item.realname || item.name
          }
        }).join(',')
      } else if (isObject(value)) {
        return value.realname || value.name || value.value
      } else if (typeof value === 'string') {
        return value
      } else {
        return value + ''
      }
    },
    getTodoList() {
      let li = this.levelInfo.todoList || []
      const customData = undefined
      const list = li.filter(item => {
        return isConditionAppen(item.conditionAppen, this.getRow, true, customData)
      })
      return list
    },
  },
  methods: {
    isAppenTag(tag) {
      const condition = tag.condition
      const flag = this.tickList.find(item => {
        if (typeof item === 'string') {
          return item === this.getRealValue
        } else if (isObject(item) && isObject(this.selInfo)) {
          if (this.selInfo && Array.isArray(this.selInfo)) {
            return item.userId === this.selInfo[0].userId
          } else if (this.selInfo && this.selInfo.userId) {
            return item.userId === this.selInfo.userId
          } else if (this.selInfo && this.selInfo.organizationId) {
            return item.organizationId === this.selInfo.organizationId
          }
        } else {
          return false
        }
      })
      if (condition === 'data' && flag) {
        return true
      } else if (condition === 'nodata' && !flag) {
        return true
      }
      return false
    }
  },
  // 侦听器
  watch: {},
}
</script>

<style scoped lang="scss">

.option-card {
  padding: 5px 0;
}

.option-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // width: 100%;
  flex: 1;
  &-text {
    flex: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  &-todo-list {
    display: flex;
    flex-wrap: nowrap;
  }
  &-tag-list {
    display: flex;
    flex-wrap: nowrap;
  }
  ::v-deep &-card {
    .el-scrollbar__wrap {
      overflow-x: scroll !important;
    }
  }
}
</style>
